<template>
<v-autocomplete ref="person" v-model="internalItem" :loading="loading" :items="items" item-text="title" item-value="_id" label="طرف حساب" @focus="onFocus" v-bind="$attrs" v-on="$listeners" :rules="requiredRules" no-data-text="اطلاعاتی موجود نیست..."
  prepend-inner-icon="mdi-account" />
</template>

<script>
import vueAxios from '../functions/vueAxios'

export default {
  name: 'MyPersons',
  props: {
    value: {
      type: [String, Number, null],
      default: null
    },
    route: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      internalItem: null, // کل object آیتم
      requiredRules: [v => !!v || 'فیلد الزامی']
    }
  },
  watch: {
    value(newVal) {
      if (!newVal || !this.items.length) {
        this.internalItem = null
        return
      }
      const found = this.items.find(i => String(i._id) === String(newVal))
      this.internalItem = found || null
    },

    internalItem(item) {
      this.$emit('input', item ? item._id : null)
    }
  },
  methods: {
    async retrieveData() {
      this.loading = true
      try {
        const res = await vueAxios.get('/persons/name')
        this.items = res ?
          res.map(item => ({
            _id: String(item._id),
            title: `${item.id} - ${item.name}`
          })) :
          []

        if (this.value != null) {
          const found = this.items.find(i => String(i._id) === String(this.value))
          this.internalItem = found || null
        }
      } catch (e) {
        console.error(e)
        this.items = []
      } finally {
        this.loading = false
      }
    },

    onFocus() {
      // setTimeout(() => {
      //   const inputEl = this.$refs.person?.$el?.querySelector('input')
      //   if (inputEl) inputEl.select()
      // }, 200)
    },
  },
  async created() {
    await this.retrieveData()
  },
  mounted() {
    if (['receipts', 'payments'].includes(this.route) && this.$refs.person) {
      this.$nextTick(() => this.$refs.person.focus())
    }
  }
}
</script>
